var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from "react";
import Dropdown from "react-bootstrap/Dropdown";
export var EquityDropdown = function (props) {
    var _a;
    var _b = __read(React.useState({
        title: props.defaultText ? props.defaultText : "",
        value: "",
    }), 2), value = _b[0], setValue = _b[1];
    var _c = __read(React.useState(false), 2), toggleIcon = _c[0], setToggleIcon = _c[1];
    var change = function (val) {
        var item = JSON.parse(val);
        setValue(item);
        props.selectedValue(item);
    };
    useEffect(function () {
        if (props.defaultVal) {
            setValue(props.defaultVal
                ? props.selectedDefaultVal
                    ? props.selectedDefaultVal
                    : props.itemlist[0]
                : {
                    title: props.defaultText ? props.defaultText : "",
                    value: "",
                });
        }
    }, [props.defaultVal, props.selectedDefaultVal]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Dropdown, { className: "equity-dropdown-block ".concat(props.externalClassname && props.externalClassname), onSelect: change },
            React.createElement(Dropdown.Toggle, { className: "equitydrop", disabled: props === null || props === void 0 ? void 0 : props.disabled },
                React.createElement("div", { className: "main-title-forbreak" }, value === null || value === void 0 ? void 0 : value.title),
                !props.hideDropdown && (React.createElement("i", { className: "edel-icon-arrow-down ".concat(props.bigIcon ? "equity-drp-bigicon" : "") }))),
            !props.hideDropdown && (React.createElement(Dropdown.Menu, { id: props.id, align: props.align, className: props.ddmenuClassName }, (_a = props === null || props === void 0 ? void 0 : props.itemlist) === null || _a === void 0 ? void 0 :
                _a.map(function (val, idx) {
                    return (React.createElement(Dropdown.Item, { className: "".concat(props.highlightSelectedItem && value.value === val.value
                            ? "DMSan_14_700 selected-item"
                            : ""), eventKey: JSON.stringify(val), key: idx, id: idx === null || idx === void 0 ? void 0 : idx.toString(), disabled: val === null || val === void 0 ? void 0 : val.disable }, val === null || val === void 0 ? void 0 :
                        val.title,
                        props.listDeleted === true ? (React.createElement(React.Fragment, null,
                            React.createElement("div", null,
                                React.createElement("i", { className: "edel-icon-trash trash" })))) : ("")));
                }),
                props.hideEdbtnlink && (React.createElement(Dropdown.Item, { eventKey: "n", key: "n" }, props.edbtnlink && React.createElement(React.Fragment, null, props.linkdata))))))));
};
